import React, { useState, useEffect } from "react";
import ReusableTable from "../../components/Employee/Table";
import {
  confirmDeletePopup,
  formatDateOnly,
  openAllowanceTypeModal,
  successPopup,
} from "../../util/common";
import TextInput from "../../components/Reusable/TextInput";
import SelectInput from "../../components/Reusable/SelectInput";
import DateInput from "../../components/Reusable/DateInput";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import "./sweetalert.css";
import { toast } from "react-toastify";
import { _useGetAllShiftSchedules } from "../../hooks/useShiftSchedules";
import {
  useDeleteWorkLocation,
  useGetAllWorkLocationsPaginated,
} from "../../hooks/useWorkLocations";
import { useQueryClient } from "@tanstack/react-query";

function WorkLocationListLayout() {
  const [pageCount, setPageCount] = useState(1);
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const [filter, setFilter] = useState({
    filterField1: "Name",
    filterValue1: null,
  });

  const handleOnPageChange = (pageIndex, pageSize) => {
    setPagination({
      page: pageIndex + 1,
      pageSize,
    });
  };

  const [workLocationRecords, setWorkLocationRecords] = useState([]);

  const {
    data: workLocationData,
    isLoading: workLocationIsLoading,
    isError: workLocationIsError,
  } = useGetAllWorkLocationsPaginated({
    page: pagination.page,
    pageSize: pagination.pageSize,
    filterField1: filter.filterField1,
    filterValue1: filter.filterValue1,
  });

  const deleteWorkLocation = useDeleteWorkLocation();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (workLocationData && workLocationData.data) {
      setWorkLocationRecords(workLocationData.data.data);
      setPageCount(workLocationData.data.pagination.totalPages);
    }
  }, workLocationData);

  const handleDelete = async (workLocation) => {
    const isConfirmed = await confirmDeletePopup({
      text: `Are you sure you want to delete ${workLocation.Name}?`,
    });

    if (isConfirmed) {
      deleteWorkLocation.mutate(workLocation.id, {
        onSuccess: (data) => {
          queryClient.invalidateQueries({
            queryKey: [
              "get-all-work-locations",
              pagination.page,
              pagination.pageSize,
              pagination.filterField1,
              pagination.filterValue1,
              pagination.filterField2,
              pagination.filterValue2,
            ],
          });
          successPopup({ text: "Work Location has been deleted." });
        },
      });
    }
  };

  const handleEdit = (workLocation) => {
    if (!workLocation) return;
    navigate(`/EditWorkLocation/${workLocation.id}`);
  };

  const tableColumns = [
    { accessorKey: "Name", header: "Name" },
    { accessorKey: "Address", header: "Address" },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const workLocation = row.original;

        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <FaEdit
              title="Edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleEdit(workLocation)}
            />

            <FaTrash
              title="Delete"
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => handleDelete(workLocation)}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="overtime-form-container">
      <h2>Work Locations List</h2>
      <form className="overtime-form">
        <div className="form-column">
          <TextInput
            label="Name"
            placeholder={"ALLOW-001"}
            onChange={(val) => {
              setFilter((prev) => ({
                ...prev,
                filterValue1: val,
              }));
            }}
            value={filter.filterValue1}
          />
        </div>

        <div className="form-group full-width file-upload-section">
          <div className="attendance-filters">
            <div className="action-btns">
              <button
                className="overtime-btn"
                onClick={() => navigate("/AddWorkLocation")}
                type="button"
              >
                + Add Work Location
              </button>
            </div>
            <div className="attendance-records">
              <ReusableTable
                data={workLocationRecords}
                columns={tableColumns}
                mode="server"
                initialPageSize={pagination.pageSize}
                onPageChange={handleOnPageChange}
                pageCount={pageCount}
                page={pagination.page - 1}
                pageSize={pagination.pageSize}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default WorkLocationListLayout;
